(function () {
  if (window.__ahsOffloadingInit) return;
  window.__ahsOffloadingInit = true;

  function getSelectedFee() {
    var checked = document.querySelector('.ahs-offloading__input:checked');
    if (!checked) return null;
    var variantId = checked.getAttribute('data-fee-variant');
    var price = parseInt(checked.getAttribute('data-fee-price'), 10) || 0;
    if (!variantId || variantId === '0' || price <= 0) return null;
    return { id: parseInt(variantId, 10), quantity: 1, properties: { '_ahs_offloading_fee': 'yes' } };
  }

  // Parse whatever shape the theme sends to /cart/add.js and return
  // { items: [...] } normalized, plus a function to re-serialize in
  // the same original shape (JSON body, FormData, or URL-encoded).
  function injectFeeIntoBody(bodyStr, fee) {
    var data;
    try {
      data = JSON.parse(bodyStr);
    } catch (e) {
      return null; // not JSON, bail — theme uses a format we don't handle
    }

    if (Array.isArray(data.items)) {
      data.items.push(fee);
    } else if (data.id) {
      // Single-item shorthand { id, quantity, properties }
      data = { items: [ { id: data.id, quantity: data.quantity || 1, properties: data.properties }, fee ] };
    } else {
      return null;
    }
    return JSON.stringify(data);
  }

  // ---- Wrap fetch ----
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isAddToCart = url.indexOf('/cart/add') !== -1 && url.indexOf('/cart/add.js') !== -1 || url.indexOf('/cart/add') !== -1;

    if (isAddToCart && init && typeof init.body === 'string') {
      var fee = getSelectedFee();
      if (fee) {
        var merged = injectFeeIntoBody(init.body, fee);
        if (merged) {
          console.log('[ahs-offloading] injecting fee into fetch add-to-cart request', fee);
          init = Object.assign({}, init, { body: merged });
        } else {
          console.warn('[ahs-offloading] could not parse add-to-cart body, fee NOT added');
        }
      }
    }

    return originalFetch.call(this, input, init);
  };

  // ---- Wrap XMLHttpRequest ----
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ahsIsAddToCart = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this.__ahsIsAddToCart && typeof body === 'string') {
      var fee = getSelectedFee();
      if (fee) {
        var merged = injectFeeIntoBody(body, fee);
        if (merged) {
          console.log('[ahs-offloading] injecting fee into XHR add-to-cart request', fee);
          body = merged;
        } else {
          console.warn('[ahs-offloading] could not parse add-to-cart body, fee NOT added');
        }
      }
    }
    return origSend.call(this, body);
  };
})();
